module.exports = __webpack_public_path__ + "img/channel.42af2022.svg";